import { useLocation } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { fetchDisclosureReportLink } from '@apis/instructions';
import { ApiRequestError } from '@app-types/api';
import { getAccessToken } from '@utils/authStorage';
import { getIframeQueryParamsFromSearch } from '@utils/queryParams';

export interface DisclosureReportLinkVariables {
  pnac: string;
  createdAt: string;
}

/** Click-triggered report-link resolver for one timely disclosure row. */
export const useDisclosureReportLink = () => {
  const location = useLocation();
  const { ticker, mkt } = getIframeQueryParamsFromSearch(location.search);

  return useMutation<string, ApiRequestError, DisclosureReportLinkVariables>({
    mutationKey: ['disclosures', 'news', 'report-link', ticker, mkt],
    mutationFn: ({ pnac, createdAt }) => {
      if (!ticker || !mkt || !getAccessToken() || !pnac || !createdAt) {
        throw new ApiRequestError(
          'Timely disclosure report link request is missing required context.',
        );
      }

      return fetchDisclosureReportLink({ ticker, mkt, pnac, createdAt });
    },
  });
};
